/**
 * @generated SignedSource<<fd61fc3b568afae1a9f4390a51f7f228>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileAvailabilityEnum = "available_now" | "available_soon" | "not_available";
export type ProfileVisibilityEnum = "visibility_clients" | "visibility_private" | "visibility_public";
export type RateMode = "day" | "hour" | "month" | "week" | "year";
export type UpdateUserInput = {
  accept?: boolean | null | undefined;
  additionalInvoiceText?: string | null | undefined;
  avatarUrl?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  currentPassword?: string | null | undefined;
  defaultPayoutMethodId?: string | null | undefined;
  displayDialogAfterSavingDraftTimesheet?: boolean | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  hidden?: boolean | null | undefined;
  lastName?: string | null | undefined;
  password?: string | null | undefined;
  passwordConfirmation?: string | null | undefined;
  payrollItemRejectionMessageDismissed?: boolean | null | undefined;
  phone?: string | null | undefined;
  profile?: ProfileAttributes | null | undefined;
  purchaseOrderNumber?: string | null | undefined;
  reject?: boolean | null | undefined;
  sendTimesheetReminders?: boolean | null | undefined;
  skills?: ReadonlyArray<UserSkillAttributes> | null | undefined;
  status?: string | null | undefined;
  summaryEmailsEnabled?: boolean | null | undefined;
  teamInvitationMessage?: string | null | undefined;
  timezoneName?: string | null | undefined;
  timezoneOffset?: number | null | undefined;
  unsubscribedFromAllEmails?: boolean | null | undefined;
  userId?: string | null | undefined;
};
export type ProfileAttributes = {
  addressRecipient?: string | null | undefined;
  availability?: ProfileAvailabilityEnum | null | undefined;
  availabilityType?: ReadonlyArray<string> | null | undefined;
  availableAt?: string | null | undefined;
  canWorkInTheUs?: boolean | null | undefined;
  cityRecipient?: string | null | undefined;
  countryRecipient?: string | null | undefined;
  currency?: string | null | undefined;
  freelancerRate?: number | null | undefined;
  industryId?: string | null | undefined;
  jobTypes?: ReadonlyArray<string> | null | undefined;
  locationBounds0?: number | null | undefined;
  locationBounds1?: number | null | undefined;
  locationBounds2?: number | null | undefined;
  locationBounds3?: number | null | undefined;
  locationLatitude?: number | null | undefined;
  locationLongitude?: number | null | undefined;
  managedTeamSize?: string | null | undefined;
  openToOpportunities?: boolean | null | undefined;
  rateMode?: RateMode | null | undefined;
  slug?: string | null | undefined;
  specializationIds?: ReadonlyArray<string> | null | undefined;
  stateRecipient?: string | null | undefined;
  taxFirm?: string | null | undefined;
  taxId?: string | null | undefined;
  textIntroduction?: string | null | undefined;
  totalExperience?: number | null | undefined;
  urlBlog?: string | null | undefined;
  urlDribbble?: string | null | undefined;
  urlGithub?: string | null | undefined;
  urlLinkedin?: string | null | undefined;
  usCitizen?: boolean | null | undefined;
  visibility?: ProfileVisibilityEnum | null | undefined;
  zip?: string | null | undefined;
};
export type UserSkillAttributes = {
  experience?: number | null | undefined;
  skillId: string;
};
export type useContactForm_Mutation$variables = {
  input: UpdateUserInput;
};
export type useContactForm_Mutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly " $fragmentSpreads": FragmentRefs<"ChatThreadMessages_User">;
    } | null | undefined;
  } | null | undefined;
};
export type useContactForm_Mutation = {
  response: useContactForm_Mutation$data;
  variables: useContactForm_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useContactForm_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ChatThreadMessages_User"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContactForm_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unconfirmedEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "integrationName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "guest",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a0de868fa8ae91316b97fe910f395900",
    "id": null,
    "metadata": {},
    "name": "useContactForm_Mutation",
    "operationKind": "mutation",
    "text": "mutation useContactForm_Mutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      ...ChatThreadMessages_User\n      id\n    }\n  }\n}\n\nfragment ChatThreadMessages_User on User {\n  email\n  unconfirmedEmail\n  integrationName\n  ...user_useIsGuest\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n"
  }
};
})();

(node as any).hash = "d2fdd1135b99402dbe30afab9ad301d1";

export default node;
